import logo from './village.jpeg';
import './App.css';
import LoginComponent from './login.js'
import { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import HouseholdComponent from './household.js';

const HomePage = () => {
  const [familyData, setFamilyData] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    const checkLoginStatus = async () => {
      try {
        const loginResponse = await fetch(`${process.env.REACT_APP_API_BASE_URL}/login${code ? `?code=${code}` : ""}`, {
          method: 'POST',
          credentials: 'include'
        });

        if (loginResponse.status === 200) {
          // print response body
          console.log('loginResponse', loginResponse);
          const householdResponse = await fetch(`${process.env.REACT_APP_API_BASE_URL}/household`, {
            method: 'GET',
            credentials: 'include'
          })

          const householdJson = await householdResponse.json();

          setFamilyData(householdJson);
          setIsLoggedIn(true);
        } else {
          setIsLoggedIn(false);
          setFamilyData(' ')
        }
      } catch (error) {
        setIsLoggedIn(false);
        console.error('Error checking login status:', error);
      }
    };

    checkLoginStatus();
  }, []); // Pass an empty array as the dependency list to run the effect only on mount


  return (
    <div className="App">
      <div className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
      </div>
      <div className="App-body App-body-center">
        {familyData == '' ? (
          <p>Loading...</p>
        ) : (
          isLoggedIn ? (
            <HouseholdComponent key={uuidv4()} data={familyData} ownHousehold={true} />
          ) : (
            <LoginComponent setIsLoggedIn={setIsLoggedIn} />
          )
        )}
      </div>
      <footer className="App-footer">
        <hr />
        <p>&copy; {(new Date().getFullYear())} Parent-AI, Inc. All rights reserved.</p>
        <p>
          <a href="tos.html">Terms of Service</a> |
          <a href="privacypolicy.html">Privacy Policy</a>
        </p>
      </footer>
    </div>

  );
}

export default HomePage;